export default {
  title: '页面不存在',
  description: '你访问的地址可能已被删除、暂时不可用，或输入的链接有误。',
  backToHome: '返回项目首页',
  goBack: '返回上一页',
}
